import { createClient } from "@supabase/supabase-js";

// Verificar que las variables existen
const supabaseUrl = "https://fgsacxsmkccogatuhofn.supabase.co";
const supabaseAnonKey = "sb_publishable__WWK9Iu8ui5JshvnSuycBQ_MJEu4WKJ";

// Flag explícito de configuración: permite que AuthContext (u otros consumidores)
// muestren un mensaje claro de "servicio no configurado" en vez de dejar
// spinners colgados o errores 401/red confusos por usar placeholders silenciosos.
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.error("[Supabase] Error: environment variables not found");
  console.error(
    "[Supabase] Create a .env file in the project root"
  );
}

// SEGURIDAD: la anon key viaja en el bundle del cliente (por diseño). Esto solo
// es seguro si TODAS las tablas (en especial 'profiles') tienen Row Level
// Security (RLS) activado con políticas que fuercen `auth.uid() = id` para
// select/update/insert. Los filtros .eq('id', user.id) del cliente NO son un
// control de acceso. Usar siempre la clave publishable/anon, NUNCA service_role.
export const supabase = createClient(
  supabaseUrl || "https://placeholder.supabase.co",
  supabaseAnonKey || "placeholder"
);
